import { StyleProp, TextStyle, TouchableOpacity, View, ViewStyle } from "react-native"

import { MaterialIcons } from "@expo/vector-icons"

import { Sentiment, SentimentIcon, useSentimentModal } from "src/context/SentimentModalContext"
import { useAppTheme } from "src/hooks/useAppTheme"
import { ThemedStyle } from "src/theme"
import { Text } from "./Ignite/Text"

export const SentimentSelect = ({
  onSentimentChange,
}: {
  onSentimentChange: (sentiment: Sentiment) => void
}) => {
  const { themed, theme } = useAppTheme()
  const { currentSentiment, setPendingSentiment } = useSentimentModal()
  const options = [Sentiment.DISSATISFIED, Sentiment.NEUTRAL, Sentiment.SATISFIED]

  return (
    <View style={$container}>
      <Text preset="subheading" style={themed($centeredText)}>
        How are you feeling?
      </Text>
      <View style={themed($iconRow)}>
        {options.map((sentiment) => (
          <TouchableOpacity
            key={sentiment}
            style={[
              themed($popoverItemButton),
              {
                borderColor:
                  sentiment === currentSentiment ? theme.colors.primary : theme.colors.border,
              },
            ]}
            onPress={() => {
              setPendingSentiment(sentiment)
              onSentimentChange(sentiment)
            }}
          >
            <MaterialIcons
              name={SentimentIcon(sentiment)}
              size={36}
              color={
                currentSentiment === sentiment
                  ? theme.colors.primary
                  : theme.colors.palette.skTextDim
              }
            />
          </TouchableOpacity>
        ))}
      </View>
    </View>
  )
}

const $centeredText: ThemedStyle<TextStyle> = ({ spacing }) => ({
  textAlign: "center",
  marginBottom: spacing.md,
})

const $container: StyleProp<ViewStyle> = {
  padding: 10,
}

const $iconRow: ThemedStyle<ViewStyle> = ({ spacing }) => ({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: spacing.md,
})

const $popoverItemButton: ThemedStyle<ViewStyle> = ({ colors, spacing }) => ({
  padding: spacing.md,
  borderRadius: 10,
  backgroundColor: colors.white,
  borderColor: colors.border,
  borderWidth: 1,
})
